export let InputColor = /*#__PURE__*/function (InputColor) {
  InputColor["available"] = "pink";
  InputColor["potentiallyAvailable"] = "orange";
  return InputColor;
}({});